'use strict'

import Axios from 'axios'
import { parseResponse, handleError } from '@/_helpers/utils.js'

export default {
  fetch (params) {
    return new Promise((resolve, reject) => {
      Axios.get('/1.0/managers', {params})
        .then(response => {
          resolve(parseResponse(response).data)
        })
        .catch(err => reject(handleError(err)))
    })
  },

  storeOne (model) {
    return new Promise((resolve, reject) => {
      Axios.post('/1.0/managers', {managers: [model]})
        .then(response => {
          resolve(parseResponse(response).data[0])
        })
        .catch(err => reject(handleError(err)))
    })
  },

  updateOne (model) {
    return new Promise((resolve, reject) => {
      Axios.put('/1.0/managers', {managers: [model]})
        .then(response => {
          resolve(parseResponse(response).data[0])
        })
        .catch(err => reject(handleError(err)))
    })
  },

  fetchPersonalManager () {
    return new Promise((resolve, reject) => {
      Axios.get(`1.0/company-personal-managers`)
        .then(response => resolve(parseResponse(response).data[0]))
        .catch(err => reject(handleError(err)))
    })
  }
}
